import { render } from "./HotspotButton.vue?vue&type=template&id=396110a2"
import script from "./HotspotButton.vue?vue&type=script&lang=js"
export * from "./HotspotButton.vue?vue&type=script&lang=js"

import exportComponent from "C:\\agent-2\\_work\\118\\s\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__